import { attr, hasMany } from '@ember-data/model';
import AbstractStayStrategyModel from 'uplisting-frontend/models/abstract-stay-strategy';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default abstract class AbstractBulkStayStrategyModel extends AbstractStayStrategyModel {
  @attr('date') from!: Date;
  @attr('date') to!: Date;

  @hasMany('property', { inverse: null, async: false })
  properties!: ModelRegistry['property'][];
}
